import { BarChart2, HeartPulse, HelpCircle, Mail, Book } from "lucide-react";
import { Link } from "wouter";
import { SuperOneLogoText } from "@components/layouts/SuperOneLogoText";
import { LinkNone1Icon } from "@radix-ui/react-icons";

export function Footer() {
  return (
    <footer className="w-full bg-gradient-to-r from-[#202842] to-[#000013] border-t border-gray-800 text-white">
      <div className="px-4 sm:px-6 lg:px-8">
        {/* Top section with links */}
        <div className="py-8 grid grid-cols-1 lg:grid-cols-[2fr_1fr_1fr] gap-8 border-b border-white/10">
          {/* Logo and About */}
          <div>
            <div className="flex items-center mb-4">
              <SuperOneLogoText />
            </div>
            <p className="text-sm text-white/70 mb-4">
              SuperOne's advanced game analytics platform provides comprehensive
              insights into player performance and game statistics.
            </p>
          </div>

          {/* Quick Links - Resources */}
          <div className="lg:text-right">
            <h3 className="text-white font-medium mb-4 flex items-center lg:justify-end">
              <Book className="h-4 w-4 mr-2 text-slate-500" />
              Resources
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  href="#"
                  className="text-white/70 hover:text-slate-500 transition-colors"
                >
                  Overview
                </Link>
              </li>
              <li>
                <Link
                  href="#"
                  className="text-white/70 hover:text-slate-500 transition-colors"
                >
                  Documentation
                </Link>
              </li>
              <li>
                <Link
                  href="#"
                  className="text-white/70 hover:text-slate-500 transition-colors"
                >
                  API Reference
                </Link>
              </li>
              <li>
                <Link
                  href="#"
                  className="text-white/70 hover:text-slate-500 transition-colors"
                >
                  Release Notes
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="lg:text-right">
            <h3 className="text-white font-medium mb-4 flex items-center lg:justify-end">
              <HelpCircle className="h-4 w-4 mr-2 text-slate-500" />
              Support
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  href="#"
                  className="text-white/70 hover:text-slate-500 transition-colors"
                >
                  Help Center
                </Link>
              </li>
              <li>
                <Link
                  href="#"
                  className="text-white/70 hover:text-slate-500 transition-colors"
                >
                  Contact Support
                </Link>
              </li>
              <li>
                <Link
                  href="#"
                  className="text-white/70 hover:text-slate-500 transition-colors"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section with copyright */}
        <div className="py-6 flex flex-col sm:flex-row items-center justify-between">
          <div className="text-xs text-white/70 mb-2 sm:mb-0">
            <div className="flex items-center">
              <HeartPulse className="h-3.5 w-3.5 text-slate-500 mr-1.5" />
              <span>Dashboard Version 0.2.0</span>
            </div>
          </div>

          <p className="text-sm text-white/70">
            © {new Date().getFullYear()}{" "}
            <span className="font-bold">superone</span>. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
